import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

export const PageContainer = styled.div`
  flex: 1;
  height: 100vh;
  overflow-y: scroll;
`;
